import React from "react";
import "./styles.css";

// Подпись поля формы.
export default function Label({ className = '', children }) {
    return <label className={`label ${className}`}>{children}</label>;
}
